import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
    InputType,
    ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_160_add_parts_request: any[] = [
    {
        "componentType": "screenGroup",
        "title": "Parts request",
        "style": {},
        "childComponents": [
            {
                "componentType": "form",
                "Name": "parts_request",
                "TableName": "parts_request",
                "columnNumber": "m1 t1 w1",
                "style": {
                    "padding": 10,
                    "backgroundColor": "#ffffff",
                    "direction": "column"
                },
                "Fields": [
                    {
                        "componentType": "fieldGroup",
                        "Label": "Parts request details",
                        "BindValue": "con_parts_request_details",
                        "style": {
                            "direction": "column"
                        },
                        "childComponents": [
                            {
                                "componentType": "textField",
                                "name": "parts_request_no",
                                "label": "PRN#",
                                "placeholder": "Will be auto generated...",
                                "required": false,
                                "inputType": "text",
                                "Json_Attribute": "parts_request_no",
                                "disabled": true,
                                "AutoPopulate": true,
                                "BindValue": "parts_request_no",
                                "AutoPopulate_format": "PRN_[******]"
                            },
                            {
                                "componentType": "dateField",
                                "name": "issue_date",
                                "label": "Request date",
                                "DefaultToday": true,
                                "BindValue": "issue_date",
                                "required": true,
                                "Json_Attribute": "issue_date",
                                "validation": [
                                    {
                                        "rule": "required",
                                        "message": "Request date is required"
                                    }
                                ]
                            },
                            {
                                "componentType": "searchableDropdown",
                                "name": "parentid",
                                "label": "Jobcard No.",
                                "placeholder": "",
                                "required": true,
                                "lookupName": "parts_request_jobcard",
                                "options": [],
                                "searchable": true,
                                "BindValue": "parentid",
                                "clearable": true,
                                "Json_Attribute": "parent_id",
                                "validation": [
                                    {
                                        "rule": "required",
                                        "message": "Jobcard No. is required"
                                    }
                                ]
                            },
                            {
                                "componentType": "textField",
                                "name": "txt_customername",
                                "label": "Customer name",
                                "placeholder": "",
                                "required": false,
                                "inputType": "text",
                                "Json_Attribute": "job_card_customername",
                                "disabled": true,
                                "BindValue": "txt_customername",
                                "BindParent": {
                                    "parentid": "customername"
                                }
                            },
                            {
                                "componentType": "textField",
                                "name": "txt_reg_no",
                                "label": "Reg No.",
                                "placeholder": "",
                                "required": false,
                                "inputType": "text",
                                "Json_Attribute": "job_card_reg_no",
                                "disabled": true,
                                "BindValue": "txt_reg_no",
                                "BindParent": {
                                    "parentid": "reg_no"
                                }
                            }
                        ]
                    },
                    {
                        "componentType": "subModule",
                        "name": "requested_items",
                        "label": "Requested details",
                        "tableName": "requested_items",
                        "BindValue": "requested_items",
                        "lookupName": "parts_request_details",
                        "parentField": "parentid",
                        "enableAddAction": false,
                        "enableEditAction": false,
                        "enableDeleteAction": false,
                        "childControls": [
                            {
                                "componentType": "textField",
                                "name": "txt_part_name",
                                "label": "Item/Part Name",
                                "placeholder": "",
                                "required": false,
                                "inputType": "text",
                                "Json_Attribute": "name",
                                "disabled": true,
                                "BindValue": "txt_part_name"
                            },
                            {
                                "componentType": "textField",
                                "name": "txt_qty",
                                "label": "Requested qty.",
                                "placeholder": "",
                                "required": false,
                                "inputType": "number",
                                "defaultValue": "0",
                                "Json_Attribute": "req_qty",
                                "disabled": true,
                                "BindValue": "txt_qty"
                            },
                            {
                                "componentType": "textField",
                                "name": "txt_item_narration",
                                "label": "Narration",
                                "placeholder": "",
                                "required": false,
                                "inputType": "text",
                                "Json_Attribute": "narration",
                                "showInSummary": false,
                                "disabled": true,
                                "BindValue": "txt_item_narration"
                            }
                        ]
                    },
                    {
                        "componentType": "subModule",
                        "name": "Parts_requested_spareparts",
                        "label": "Part details",
                        "tableName": "parts_request_details",
                        "BindValue": "sub_Checklist",
                        "lookupName": "Parts_requested_spareparts",
                        "parentField": "parentid",
                        "enableEditAction": false,
                        "enableDeleteAction": true,
                        "childControls": [
                            {
                                "componentType": "textField",
                                "name": "est_ref_id",
                                "label": "",
                                "placeholder": "",
                                "required": false,
                                "inputType": "text",
                                "Json_Attribute": "est_ref_id",
                                "disabled": true,
                                "IsHidden": true,
                                "BindValue": "est_ref_id",
                                "style": {
                                    "display": "none"
                                }
                            },
                            {
                                "componentType": "searchableDropdown",
                                "name": "drp_code",
                                "label": "Part No.",
                                "placeholder": "Search part number or description",
                                "required": true,
                                "lookupName": "product_itemcode",
                                "options": [],
                                "searchable": true,
                                "clearable": true,
                                "Json_Attribute": "codeid",
                                "BindValue": "drp_code",
                                "validation": [
                                    {
                                        "rule": "required",
                                        "message": "Part selection is required"
                                    }
                                ]
                            },
                            {
                                "componentType": "textField",
                                "name": "txt_item_name",
                                "label": "Item Name",
                                "placeholder": "",
                                "required": false,
                                "inputType": "text",
                                "Json_Attribute": "item_name",
                                "disabled": true,
                                "BindValue": "txt_item_name",
                                "BindParent": {
                                    "drp_code": "item_name"
                                }
                            },
                            {
                                "componentType": "textField",
                                "name": "txt_qty",
                                "label": "Requested qty.",
                                "placeholder": "",
                                "required": false,
                                "inputType": "number",
                                "defaultValue": "0",
                                "Json_Attribute": "qty",
                                "BindValue": "txt_qty",
                                "validation": [
                                    {
                                        "rule": "pattern",
                                        "value": "^(?!0+(?:\\.0+)?$)\\d+(?:\\.\\d+)?$",
                                        "message": "Request quantity should be greater than zero"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "componentType": "button",
                "Label": "Request",
                "name": "Request",
                "onPressAction": "save",
                "style": {
                    "textColor": "#FFFFFF",
                    "padding": 10,
                    "borderRadius": 8
                }
            }
        ]
    }
];
